import script from "./OkrModuleActions.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrModuleActions.vue?vue&type=script&setup=true&lang=js"

import "./OkrModuleActions.vue?vue&type=style&index=0&id=00432874&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00432874"]])

export default __exports__